<template>
  <div
    class="flex items-center gap-x-1"
    :class="colorClass[params.value]"
  >
    <CheckCircleIcon
      v-if="params.value === STATUS.COMPLETE"
      class="ag-grid-cell-ico"
    />
    <ExclamationCircleIcon
      v-else-if="params.value === STATUS.FAILED || params.value === STATUS.CANCELLED"
      class="ag-grid-cell-ico"
    />
    <ClockIcon
      v-else
      class="ag-grid-cell-ico"
    />
    <span>{{ params.value }}</span>
  </div>
</template>

<script setup>
import { CheckCircleIcon } from '@heroicons/vue/outline'
import { ExclamationCircleIcon, ClockIcon } from '@heroicons-2/vue/24/outline'

/**
 * @typedef {Object} StatusCellParams
 * @param {String} value
 */
const props = defineProps({
  /** @type {StatusCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const STATUS = {
  CANCELLED: 'Cancelled',
  FAILED: 'Failed',
  COMPLETE: 'Complete'
}

const colorClass = {
  [STATUS.CANCELLED]: 'text-gray-600',
  [STATUS.FAILED]: 'text-red-400',
  [STATUS.COMPLETE]: 'text-blue-400'
}
</script>
